import Switch from "@ui/Switch";
import React from "react";
import t from "../../../../../i18n";

interface P {
  checked: boolean;
  onChange: () => void;
  disabled: boolean;
}

export const DisplayAllFaultsSwitch = ({ checked, onChange, disabled }: P) => (
  <Switch checked={checked} onChange={onChange} disabled={disabled}>
    <span
      title={
        disabled && !checked
          ? t("project.fault_event.quantity_selector.switch.display_all_faults.tooltip.disabled")
          : undefined
      }
    >
      {t("project.chart.legend.fault_event.switch.display_all_faults.label")}
    </span>
  </Switch>
);
